@if (
  {
    onStepNext: onStepNext$ | async,
    onStepPrevious: onStepPrevious$ | async
  };
  as STATE
) {
  <main class="onboarding-stepper">
    <header class="onboarding-stepper__header">
      <img src="assets/icons/logo.png" alt="Logo" />
      <hgroup>
        <h1>Finaliser mon inscription</h1>
        <p>Complétez votre profil pour commencer à facturer en conformité.</p>
      </hgroup>
    </header>

    <mat-divider class="form__divider onboarding__divider-space"></mat-divider>

    <mat-stepper
      #stepper
      (selectionChange)="emitStepChange($event)"
      linear
      animationDuration="0"
      [selectedIndex]="0"
    >
      <ng-template matStepperIcon="number" let-index="index">
        {{ index + 1 }}
      </ng-template>
      <ng-template matStepperIcon="edit" let-index="index">
        {{ index + 1 }}
      </ng-template>
      <ng-template matStepperIcon="done" let-index="index">
        {{ index + 1 }}
      </ng-template>

      <mat-step [state]="states[0]">
        <onboarding-form></onboarding-form>
      </mat-step>

      <mat-step [state]="states[1]">
        <billing-equipment-declaration-form></billing-equipment-declaration-form>
      </mat-step>

      <mat-step [state]="states[2]">
        <onboarding-summary></onboarding-summary>
      </mat-step>
    </mat-stepper>
  </main>
}
